import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
	w: z
		.string()
		.regex(/^[A-Za-z0-9_-]+$/)
		.optional()
		.catch(undefined),
})

export const Route = createFileRoute('/projects/devino')({
	component: lazyRouteComponent(
		() => import('@/teams/devino/pages/devino-page/devino-page.tsx'),
		'DevinoPage',
	),
	validateSearch: searchSchema,
})
